// extracted by mini-css-extract-plugin
export default {"contentWrapper":"styles_contentWrapper__3+7mh"};